import React from "react";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { appLogger } from "../../utils";

const Comments = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "Comments",
      component: "feedback",
      fileName: "comments.tsx",
      props: props,
    },
  });
  const { comments, feedbackDetails } = props;
  const RenderNumber = (props: any) => {
    return <div>{parseInt(props.val, 10) + 1}</div>;
  };

  if (comments && Object.keys(comments).length > 0) {
    let commentText = "";
    Object.keys(comments).forEach((comment: string) => {
      if (comments[comment] && comments[comment].message) {
        commentText = commentText + "\n" + comments[comment].message;
      }
      if (comments[comment] && comment === "generalComment") {
        commentText = commentText + "\n" + comments[comment];
      }
    });

    const sortedKeys = Object.keys(comments).sort((a: string, b: string) => {
      if (a === "standardFeedback") {
        return -1;
      }
      if (b === "standardFeedback") {
        return 1;
      }
      if (isNaN(parseInt(a, 10))) return -1;
      if (isNaN(parseInt(b, 10))) return 1;
      if (a > b) return 1;
      if (b > a) return -1;
      return 0;
    });
    appLogger.info({
      infoObj: {
        method: "Comments",
        component: "feedback",
        fileName: "comments.tsx",
        category: props.categor,
        comments: comments,
      },
    });

    return (
      <div>
        <div>
          {comments["standardFeedback"] &&
          props.category &&
          comments["standardFeedback"].length > 0 ? (
            <div>
              {/* <Typography component="label">{`${props.category} related ${
                props.feedbackType ? "Bugs" : "Feedbacks"
              }`}</Typography> */}
              <Typography className="title-sm1">Standard Feedback</Typography>
              {comments["standardFeedback"].map((el: string, i: number) => {
                return (
                  <>
                    <Typography className="info" key={el + i.toString()}>
                      {el}
                    </Typography>
                  </>
                );
              })}
            </div>
          ) : (
            <div />
          )}
        </div>
        <div>
          {props.category ? (
            Array.isArray(props.category) ? (
              typeof props.category !== "string" &&
              props.category.map((cat: string, index: number) =>
                comments[cat] && comments[cat].length > 0 ? (
                  <div>
                    {/* <Typography component="label">{`${props.category} related ${
                      props.feedbackType ? "Bugs" : "Feedbacks"
                    }`}</Typography> */}
                    {comments[cat].map((el: string, i: number) => {
                      return (
                        <Typography className="info" key={el + i.toString()}>
                          {el}
                        </Typography>
                      );
                    })}
                  </div>
                ) : (
                  <div />
                )
              )
            ) : typeof props.category === "string" &&
              comments[props.category] &&
              comments[props.category].length > 0 ? (
              <div>
                {/* <Typography component="label">{`${props.category} related ${
                  props.feedbackType ? "Bugs" : "Feedbacks"
                }`}</Typography> */}
                {comments[props.category].map((el: string, i: number) => {
                  return (
                    <Typography className="info" key={el + i.toString()}>
                      {el}
                    </Typography>
                  );
                })}
              </div>
            ) : (
              <div />
            )
          ) : (
            <div />
          )}
        </div>
        <div>
          {feedbackDetails?.inputSource != "chat" &&
          Object.keys(comments).length > 2 ? (
            <Box sx={{ marginTop: "10px" }}>
              <Typography className="title-sm1">
                Screen shot comments
              </Typography>
              {sortedKeys.map((key: string) => {
                if (comments[key].message) {
                  return (
                    <div key={key} style={{ display: "flex" }}>
                      <RenderNumber val={key} />
                      <div
                        style={{
                          marginLeft: ".5rem",
                        }}
                      >
                        {comments[key].message}
                      </div>
                    </div>
                  );
                }
              })}
            </Box>
          ) : (
            <div />
          )}
        </div>
        <div>
          {comments["generalComment"] ? (
            <Box sx={{ pt: 1 }}>
              <Typography className="title-sm1">General Comments</Typography>
              <Typography className="info">
                {comments["generalComment"]}
              </Typography>
            </Box>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }
  return <div>-</div>;
};

export default Comments;
